import React from 'react';

import styles from './WowHeader.scss';
import classNames from 'classnames/bind';
import {Link} from 'react-router-dom';
// import { faLanguage } from '@fortawesome/free-solid-svg-icons';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBars } from '@fortawesome/free-solid-svg-icons';
// import {Link} from 'react-router-dom';

const cx = classNames.bind(styles);

const Header = ({fnLanguage,lang}) => {
  // const {pathname} = window.location;

  const selColor = {
    backgroundColor: '#5C423D',
    border:'1px solid gray',
    padding:'0.2em 0.4em 0.2em 0.4em'
  }
  const nonColor = {
    border:'1px solid gray',
    padding:'0.2em 0.4em 0.2em 0.4em'
  }

  return (
    <header>
      <div className={cx('top-menu')}>
        <div className={cx('logo')}>
          <div className={cx('title')}>
            <Link to="/wow">
              <span className={cx('main-title')}>WOW FIND</span>
            </Link>
            <Link to="/wow">
              <span className={cx('menu-title')}>WCL TOP100</span>
            </Link>
            {/* <Link to="/wowbis">
              <span className={cx('menu-title')}>BisItem Season3</span>
            </Link> */}
          </div>
        </div>

        <span className={cx('kreng')}>
          <button onClick={() => fnLanguage('kr')} style={lang==='kr'?selColor:nonColor}>KR</button>
          <button onClick={() => fnLanguage('eng')} style={lang==='eng'?selColor:nonColor}>ENG</button>
        </span>
      </div>
      <div className={cx('bottom-menu')}>
        <ul>
          <li className={cx('menu-item')}><Link to="/wow">WCL TOP100</Link></li>
          <li className={cx('menu-item')}><Link to="/wowbis">BisItem Season3</Link></li>
        </ul>
      </div>
    </header>
  );
};

export default Header;